import { TableHeaderCell, TableRow, TableHeader } from 'components/table';
import { Button } from 'components/button';
import Icon from 'components/icon/Icon';
import { SORT_TYPES } from 'utils/sort';
import { useResultsPanelContext } from 'contexts/ResultsPanelContext';
import FieldSelect from 'components/input/FieldSelect';
import messages from 'messages.js';
import { useIntl } from 'react-intl';
import { useStore } from 'stores/Store';
import { useEffect } from 'react';
import useUrlQuery from 'hooks/utils/useUrlQuery';

const ResultsTableHeader = () => {
  let query = useUrlQuery();
  const intl = useIntl();
  const {
    testItems,
    groupedTestItems,
    usersArray,
    onChangePersonCol,
    onChangeTestCol,
    onSort,
    onSortPersons,
    sortIndex,
    personsSortDirection
  } = useResultsPanelContext();

  const selectedHeaders = useStore(state => state.selectedHeaders);
  const { setSelectedHeaders, setSelectedHeader } = useStore(state => state);

  useEffect(() => {
    const tests = query.get('tests');
    if (tests) {
      const testsArray = tests.split(',');
      const testIds = [];
      testsArray.forEach(test => {
        testIds.push({ id: test, sortDirection: SORT_TYPES.DOWN });
      });
      setSelectedHeaders([...testIds]);
    }
  }, [query]);

  const onSelectTestHandler = (index, value) => {
    setSelectedHeader({ index, value });

    const testIds = selectedHeaders.map(item => item.id);
    const testsQuery = testIds.join(',');

    onChangeTestCol(selectedHeaders);

    query.set('tests', testsQuery);
    window.history.replaceState(null, null, `?${query.toString()}`);
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHeaderCell>
          <FieldSelect
            name={`personFilter`}
            placeholder={intl.formatMessage(
              messages.resultsTableHeaderSelectAthletes
            )}
            onChange={(option, action) => {
              onChangePersonCol(option, action);
            }}
            label={intl.formatMessage(
              messages.resultsTableHeaderFilterByAthlete
            )}
            options={usersArray.current.map(u => ({
              value: u.id,
              label: u.label
            }))}
            isClearable
            isSearchable
            isMulti
            styles={{
              container: { width: '100%' },
              option: { textAlign: 'left' }
            }}
            labelHiddenVisually
            minMenuHeight={260}
            maxMenuHeight={260}
            customMultiValue
          />
          <Button
            tiny
            inactive={true}
            onClick={() => {
              onSortPersons();
            }}
            disabled={false}
            extraClassNames={'u-margin-left-small'}
          >
            <Icon
              id={
                personsSortDirection
                  ? `sort-${personsSortDirection ? 'down' : 'up'}`
                  : 'sort'
              }
            />
          </Button>
        </TableHeaderCell>
        {selectedHeaders.map((col, i) => {
          const isSortIndex = i === sortIndex;
          const selectedGroup = groupedTestItems.find(group =>
            group.options.find(o => o.value === col.id)
          );
          const selectedGroupOption = selectedGroup?.options.find(
            o => o.value === col.id
          );
          return (
            <TableHeaderCell refactoring key={i} data-col={i}>
              <FieldSelect
                onTable
                labelGroup={selectedGroup?.label || null}
                name={`test-set-${i}`}
                options={groupedTestItems}
                value={selectedGroupOption}
                onChange={option => {
                  onSelectTestHandler(i, option?.value ?? null);
                }}
                placeholder={
                  !testItems.length
                    ? intl.formatMessage(messages.resultsTableHeaderNoTestItems)
                    : intl.formatMessage(
                        messages.resultsTableHeaderSelectTestItem
                      )
                }
                noOptionsMessage={() =>
                  intl.formatMessage(messages.resultsTableHeaderNoTestItems)
                }
                disabled={!testItems.length}
                isClearable
                isSearchable
                styles={{
                  container: { width: '100%' },
                  option: { textAlign: 'left' }
                }}
                minMenuHeight={260}
                maxMenuHeight={260}
              />
              <Button
                tiny
                inactive={!isSortIndex}
                onClick={() => {
                  const newDirection = !isSortIndex
                    ? SORT_TYPES.DOWN
                    : col.sortDirection === SORT_TYPES.DOWN
                      ? SORT_TYPES.UP
                      : SORT_TYPES.DOWN;
                  onSort(i, newDirection);
                }}
                disabled={!col.id}
              >
                <Icon id={isSortIndex ? `sort-${col.sortDirection}` : 'sort'} />
              </Button>
            </TableHeaderCell>
          );
        })}
      </TableRow>
    </TableHeader>
  );
};

export default ResultsTableHeader;
